/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateDraftsDto } from '../../models/lexplus-create-drafts-dto';
import { LexplusMailDraftDto } from '../../models/lexplus-mail-draft-dto';

export interface EmailTemplateControllerCreateDraftsV1$Params {
  id: string;
      body: LexplusCreateDraftsDto
}

export function emailTemplateControllerCreateDraftsV1(http: HttpClient, rootUrl: string, params: EmailTemplateControllerCreateDraftsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusMailDraftDto>>> {
  const rb = new RequestBuilder(rootUrl, emailTemplateControllerCreateDraftsV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusMailDraftDto>>;
    })
  );
}

emailTemplateControllerCreateDraftsV1.PATH = '/v1/email-templates/{id}/drafts';
